import DeleteSweepOutlinedIcon from "@mui/icons-material/DeleteSweepOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHorizRounded";
import { IconButton, Menu } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ActionMenuItem from "@entrilia/shared/components/ActionMenuItem";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { selectEditDisabled } from "../../../../store/selectors/uiSettingsSelectors";
import { useAppStore } from "../../../../store/store";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks";
import { observeEditingHistory } from "../../../../store/utils/observeEditingHistory";

export default function BuilderMoreAction() {
  const store = useAppStore();
  const dispatch = useAppDispatch();
  const editDisabled = useSelector(selectEditDisabled);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  useEffect(() => observeEditingHistory(store), [store]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClearConfiguration = () => {
    if (editDisabled) {
      return;
    }
    dispatch(fieldsStateActions.clearCurrentConfiguration());
    handleClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick} disabled={editDisabled}>
        <MoreHorizIcon sx={(theme) => ({ color: theme.palette.secondary.light })} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <ActionMenuItem
          icon={<DeleteSweepOutlinedIcon color="secondary" />}
          title="Clear Configuration"
          onClick={handleClearConfiguration}
          disabled={editDisabled}
        />
      </Menu>
    </>
  );
}
